import React from 'react';
import { createStyles, Theme } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

export type Size = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';

export const SIZES = {
  large: 64,
  medium: 48,
  small: 32,
  xlarge: 130,
  xsmall: 16,
};

const getAvatarFontSize = (size: Size, theme: Theme) => {
  return {
    large: theme.fontSizes.large,
    medium: theme.fontSizes.small,
    small: theme.fontSizes.small,
    xlarge: 48,
    xsmall: 8,
  }[size];
};

const getAvatarStyle = (size: Size, uuid: string) => {
  const diameter = SIZES[size];
  return {
    backgroundColor: `#${uuid.substr(0, 6)}`,
    borderRadius: diameter,
    height: diameter,
    width: diameter,
  };
};

export const getAvatarText = (name: string) => {
  const parts = name.split(' ').filter((part) => part);
  if (parts.length === 0) {
    return '';
  } else if (parts.length > 1) {
    return `${parts[0][0]}${parts[1][0]}`;
  }

  return parts[0][0] || '';
};

export interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  name: string;
  size?: Size;
  uuid: string;
}

export const Avatar: React.FC<Props> = ({
  containerStyle,
  name,
  size = 'medium',
  uuid,
}) => {
  const [styles, theme] = useStyles();
  return (
    <View style={[styles.avatar, getAvatarStyle(size, uuid), containerStyle]}>
      <Text
        style={[
          styles.avatarLetter,
          {
            fontSize: getAvatarFontSize(size, theme),
          },
        ]}
      >
        {getAvatarText(name).toUpperCase()}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  avatar: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarLetter: {
    ...FONTS.primaryBold,
    color: theme.colors.white,
    textAlign: 'center',
  },
}));
